import React, { useEffect } from 'react'
import { Button, CircularProgress, Grid } from '@material-ui/core'
import termoEPoliticaRepository from './TermoEPoliticaRepository'
import CopyToClipboardButton from '../../../../components/CopyToClipboardButton'
import config from '../../../../Config'

const ReenviarTermo = ({ handleReenviar, actionLoading, message }) => {
  return (
    <Button
      fullWidth
      onClick={handleReenviar}
      color="primary"
      variant="contained"
      disabled={actionLoading}
    >
      {actionLoading && <CircularProgress size={24} />}
      {message || 'Reenviar termo'}
    </Button>
  )
}

const StatusComponent = ({ status, termoId, urlId, embarcador = false }) => {
  const [message, setMessage] = React.useState('')
  const [actionLoading, setActionLoading] = React.useState(false)
  const parsedTermoId = termoId || null

  const fullUrl = `${config.gestaoConformidadesUrl}/aceite/${urlId}`

  const handleReenviar = async () => {
    setActionLoading(true)
    if (!parsedTermoId) {
      setMessage('Termo não encontrado!')
      setActionLoading(false)
      return
    }

    const response = await termoEPoliticaRepository.reenviar({
      termoId: parsedTermoId
    })

    if (response.data?.ok && response.ok) {
      setMessage('Termo enviado com sucesso!')
    } else {
      setMessage(response.data.data.msg || 'Erro ao enviar o termo!')
    }
    setActionLoading(false)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMessage('')
    }, 3000)

    return () => {
      clearTimeout(timeout)
    }
  }, [message])

  if (embarcador) {
    if (status === 'AGUARDANDO_ACEITE') {
      return (
        <Grid item xs={6}>
          <CopyToClipboardButton
            variant="outlined"
            buttonMessage="Copiar link do termo"
            snackbarMessage="Link copiado com sucesso"
            copyContent={fullUrl}
          />
        </Grid>
      )
    }

    return null
  }

  switch (status) {
    case 'ENVIO_PENDENTE':
      return (
        <Grid item xs={12}>
          <ReenviarTermo
            handleReenviar={handleReenviar}
            actionLoading={actionLoading}
            message={message}
          />
        </Grid>
      )
    case 'AGUARDANDO_ACEITE':
      return (
        <>
          <Grid item xs={6}>
            <ReenviarTermo
              handleReenviar={handleReenviar}
              actionLoading={actionLoading}
              message={message}
            />
          </Grid>
          <Grid item xs={6}>
            <CopyToClipboardButton
              fullwidth
              variant="outlined"
              buttonMessage="Copiar link do termo"
              snackbarMessage="Link copiado com sucesso"
              copyContent={fullUrl}
            />
          </Grid>
        </>
      )
    default:
      return null
  }
}

export default StatusComponent
